import { Location } from '@reach/router';
import { css } from 'astroturf';
import React from 'react';

import { ArrowRight } from 'react-bytesize-icons';
import Link from './link';

const styles = css`
  .topbar {
    position: relative;
    text-align: center;
    line-height: 1.2;
    color: #fff;
    padding: 0.5rem;
    font-weight: 500;
    overflow: hidden;
    z-index: 2;
    display: flex;
    height: auto;
    min-height: 48px;
    margin: 0;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    font-weight: bold;
    background: #353546;
    box-shadow:
      rgba(255, 255, 255, 0.2) 0px 1px 1px 0px inset,
      rgba(50, 50, 93, 0.3) 0px 50px 100px -20px,
      rgba(0, 0, 0, 0.4) 0px 30px 60px -30px;

    & .button {
      position: relative;
      outline: none;
      align-self: center;
      z-index: 2;
      border: 0;
      line-height: 1;
      border-radius: 100px;
      font-size: 1rem;
      color: #fff;
      font-weight: 700;
      white-space: nowrap;
      opacity: 1;
      padding: 0.5rem 1rem;
      background: linear-gradient(135deg, #4ca2cd, ease-in-out, #67b26f);
      background-image: linear-gradient(135deg, oklab(0.61 -0.08 -0.21), oklab(0.66 -0.24 0.16));
      transition: 0.25s ease-in-out;

      & svg {
        vertical-align: top;
        margin-left: 0.5rem;
        transition: 0.25s ease-in-out;
      }

      @media (max-width: 56rem) {
        display: none;
      }
    }
    &:hover,
    &:focus {
      & .button {
        background: linear-gradient(135deg, #4ca2cd, ease-in-out, #67b26f);
        background-image: linear-gradient(135deg, oklab(0.61 -0.08 -0.21), oklab(0.66 -0.24 0.16));

        & svg {
          translate: 5px 0;
        }
      }
    }

    & > span {
      filter: drop-shadow(0px 3px 0px #000);
    }
  }

  .punchout {
    background: linear-gradient(135deg, #2c82ad, ease-in-out, #67b26f);
    background-image: linear-gradient(135deg, oklab(0.61 -0.08 -0.21), oklab(0.66 -0.24 0.16));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    background-clip: text;
  }
`;

function Topbar({page}) {
  return (
    <Location>
      {({ location }) => (
        <>
          {['/docs/'].includes(location.pathname) ? (
            <></>
          ) : (
            <Link to="/black-friday/" className={styles.topbar}>
              <span>
                ✨ Our <span className={styles.punchout}>Black Friday Sale</span> is here ✨
              </span>
              <span className={styles.button}>
                Get Polypane <ArrowRight width={16} height={16} strokeWidth="4px" />
              </span>
            </Link>
          )}
        </>
      )}
    </Location>
  );
}

export default Topbar;
